import { RESPONSEDATA } from "app/shared/services/services-model.type";
import {
  FETCH_TRANSFER_CASH_BY_CODE_CREATE_REQUEST,
  FETCH_TRANSFER_CASH_BY_CODE_CREATE_SUCCESS,
  FETCH_TRANSFER_CASH_BY_CODE_CREATE_FAILURE,
  FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_REQUEST,
  FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_SUCCESS,
  FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_FAILURE,
  FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_FAILURE,
} from "./actions.type";
import {
  FetchTransferCashByCodeCreateRequest,
  FetchTransferCashByCodeCreateSuccess,
  FetchTransferCashByCodeCreateFailure,
  FetchTransferCashByCodeConfirmRequest,
  FetchTransferCashByCodeConfirmSuccess,
  FetchTransferCashByCodeConfirmFailure,
  FetchTransferCashByCodeAuthorizationRequest,
  FetchTransferCashByCodeAuthorizationSuccess,
  FetchTransferCashByCodeAuthorizationFailure,
} from "./types";

// Cash by code
export const fetchTransferCashByCodeCreateRequest = (): FetchTransferCashByCodeCreateRequest => ({
  type: FETCH_TRANSFER_CASH_BY_CODE_CREATE_REQUEST,
});

export const fetchTransferCashByCodeCreateSuccess = (payload?: RESPONSEDATA): FetchTransferCashByCodeCreateSuccess => ({
  type: FETCH_TRANSFER_CASH_BY_CODE_CREATE_SUCCESS,
  payload,
});

export const fetchTransferCashByCodeCreateFailure = (error?: string): FetchTransferCashByCodeCreateFailure => ({
  type: FETCH_TRANSFER_CASH_BY_CODE_CREATE_FAILURE,
  error,
});

export const fetchTransferCashByCodeConfirmRequest = (): FetchTransferCashByCodeConfirmRequest => ({
  type: FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_REQUEST,
});

export const fetchTransferCashByCodeConfirmSuccess = (payload?: RESPONSEDATA): FetchTransferCashByCodeConfirmSuccess => ({
  type: FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_SUCCESS,
  payload,
});

export const fetchTransferCashByCodeConfirmFailure = (error?: string): FetchTransferCashByCodeConfirmFailure => ({
  type: FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_FAILURE,
  error,
});

export const fetchTransferCashByCodeAuthorizationRequest = (): FetchTransferCashByCodeAuthorizationRequest => ({
  type: FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_REQUEST,
});

export const fetchTransferCashByCodeAuthorizationSuccess = (payload?: RESPONSEDATA): FetchTransferCashByCodeAuthorizationSuccess => ({
  type: FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchTransferCashByCodeAuthorizationFailure = (error?: string): FetchTransferCashByCodeAuthorizationFailure => ({
  type: FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_FAILURE,
  error,
});
